import {
  devFeaturesStateSelector,
  ThemeModePreference,
} from "@store/dev-features/dev-features-slice";
import { useAppSelector } from "@store/store-helper";

/** @returns the colour scheme the user chose, where "system" is left for the browser to resolve */
export function useThemeMode(): ThemeModePreference {
  return useAppSelector(devFeaturesStateSelector).themeMode;
}
